export default async function InsertPaymentDetails(sendForm) {
    let url = window.RealestateService+  `/api/PaymentDetails/InsertPaymentDetails`
    let head = {
        // 'content-type': 'multipart/form-data',
        // "accept":"*/*"
    }
    let data ={}
    let response  = await fetch(url, {
        method:"POST",
        headers:head,
        body:sendForm
    }).then(res=>res.json()).then(data)

    return response
}